import React from 'react';

/**
 * AdaliaLogo — identité de la plateforme ADALIA (de l'arabe « ʿadl » : la justice).
 *
 * Emblème : une BALANCE de la justice minimaliste, géométrique, en OR
 * (#C9A227) — écho direct à la vidéo de login. Vectoriel (SVG) → net à
 * toute taille, léger, thémable.
 *
 * Props :
 *  - size     : hauteur de l'emblème en px (défaut 30)
 *  - variant  : 'full' (emblème + mot « Adalia ») | 'mark' (emblème seul)
 *  - color    : couleur du mot (défaut var(--text-primary))
 *  - gold     : couleur de l'emblème (défaut #C9A227)
 */
export default function AdaliaLogo({ size = 30, variant = 'full', color = 'var(--text-primary)', gold = '#C9A227' }) {
  const mark = (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      role="img"
      aria-label="Adalia"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'block', flexShrink: 0 }}
    >
      {/* Fléau (le bras horizontal) */}
      <path d="M10 18 H54" stroke={gold} strokeWidth="3" strokeLinecap="round" />
      {/* Pivot */}
      <circle cx="32" cy="18" r="2.8" fill={gold} />
      {/* Colonne + socle */}
      <path d="M32 18 V53" stroke={gold} strokeWidth="3" strokeLinecap="round" />
      <path d="M23 54 H41" stroke={gold} strokeWidth="3" strokeLinecap="round" />
      {/* Chaînes */}
      <path d="M10 18 V25" stroke={gold} strokeWidth="1.6" strokeLinecap="round" />
      <path d="M54 18 V25" stroke={gold} strokeWidth="1.6" strokeLinecap="round" />
      {/* Plateaux */}
      <path d="M3 25 Q10 37 17 25" stroke={gold} strokeWidth="2.6" strokeLinecap="round" />
      <path d="M47 25 Q54 37 61 25" stroke={gold} strokeWidth="2.6" strokeLinecap="round" />
    </svg>
  );

  if (variant === 'mark') return mark;

  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: size * 0.34 }}>
      {mark}
      <span
        style={{
          color,
          fontWeight: 600,
          letterSpacing: '0.02em',
          fontSize: Math.round(size * 0.64),
          lineHeight: 1,
          fontFamily: "'Newsreader', Georgia, 'Times New Roman', serif",
        }}
      >
        Adalia
      </span>
    </div>
  );
}
